<mat-card class="contact-admin-wrapper">
  <mat-icon class="large-icon">block</mat-icon>
  <h1 class="contact-admin-title">Restricted Access</h1>
  <p class="contact-admin-description">
    Your user profile is not recognized. Please reach out to the LoadBoard team to request access.
  </p>
</mat-card>
